import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTemplates = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API}/templates`);
      setTemplates(response.data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching templates:', err);
    } finally {
      setLoading(false);
    }
  };

  const createTemplate = async (templateData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${API}/templates`, templateData);
      await fetchTemplates();
      return response.data;
    } catch (err) {
      setError(err.message);
      console.error('Error creating template:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const importBlockbench = async (file, name, category) => {
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', name);
      formData.append('category', category);

      const response = await axios.post(
        `${API}/templates/import-blockbench`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      await fetchTemplates();
      return response.data;
    } catch (err) {
      setError(err.message);
      console.error('Error importing Blockbench file:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteTemplate = async (templateId) => {
    setLoading(true);
    setError(null);
    try {
      await axios.delete(`${API}/templates/${templateId}`);
      await fetchTemplates();
    } catch (err) {
      setError(err.message);
      console.error('Error deleting template:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return {
    templates,
    loading,
    error,
    fetchTemplates,
    createTemplate,
    importBlockbench,
    deleteTemplate,
  };
};
